import { Injectable } from '@angular/core';
import { BaseProvider } from './base';

@Injectable()
export class NumberProvider extends BaseProvider {
    constructor() {
        super();
    }

    /**
     * Rounds a number to a specific number of decimal places
     *
     * @param {number} num Number to be rounded
     * @param {number} decimal number of decimals from which to round (e.g. 0=3, 1=3.1, 2=3.14, etc)
     * @returns {number} Rounded number to specific decimal point value
     * @memberof NumberProvider
     */
    public round(num: number | null | undefined, decimal: number): number | null | undefined {
        if (num === null || num === undefined) {
            return num;
        }

        const decimalPlace = Math.pow(10, decimal);
        return Math.round(num * decimalPlace) / decimalPlace;
    }

    /**
     * Returns a comma-delineated string version of a number
     *
     * @param {number} data Value to be converted
     * @returns {string} The comma-delineated string literal version of the input
     * @memberof NumberProvider
     */
    public getCommaDelineatedNumStr(data: number | null | undefined): string {
        if (data === null || data === undefined) {
            return '';
        }

        let dataStr = `${data}`;
        let reversedStr = '';
        if (data >= 1000) {
            let commaCounter = 3;
            for (let i = dataStr.length - 1; i >= 0; i--) {
                if (commaCounter == 0) {
                    reversedStr += `,${dataStr[i]}`;
                    commaCounter = 2;
                } else {
                    reversedStr += `${dataStr[i]}`;
                    commaCounter -= 1;
                }
            }
            dataStr = '';
            for (let i = reversedStr.length - 1; i >= 0; i--) {
                dataStr += reversedStr[i];
            }
        }

        return `${dataStr}`;
    }

    /**
     * Get a formatted version of the time represented in a date object
     *
     * @param date Date
     * @param clipLeadingZeros Boolean (optional) trim leading zeros for smaller time values (e.g. 00:02:16 => 02:16)
     *
     * @return string date in hh:mm:ss format
     */
    public getHoursMinutesSecondsFromDate(date: Date, clipLeadingZeros = false): string {
        let dateString = date.toISOString().substr(11, 8);
        if (clipLeadingZeros) {
            while (dateString.charAt(0) == '0' || dateString.charAt(0) == ':') {
                const shouldBreak = dateString.charAt(0) == ':';
                dateString = dateString.substr(1);
                if (shouldBreak) {
                    break;
                }
            }
        }

        return dateString;
    }
}



// WEBPACK FOOTER //
// ./src/providers/number.ts